import React from 'react';
import PieceViewer from '../components/PieceViewer';

const PiecePage = ({ selectedPiece, addFavorite, removeFavorite, isFavorited }) => {
  return (
    <div>
      <div className="container">
        <PieceViewer
          selectedPiece={selectedPiece}
          addFavorite={addFavorite}
          removeFavorite={removeFavorite}
          isFavorited={isFavorited}
        />
      </div>
    </div>
  );
};

export default PiecePage;
